<template>
  <section class="property-details">
    <image-gallery :images="activeProperty.images" />
    <div
      class="content long-description"
      v-html="sanitizedDescription"
    />
  </section>
</template>

<script>
import DOMPurify from 'dompurify'
import { mapGetters } from 'vuex'
import ImageGallery from '@/components/ImageGallery.vue'

export default {
  name: 'PropertyDetails',

  components: { ImageGallery },

  computed: {
    ...mapGetters(['activeProperty']),

    sanitizedDescription () {
      return DOMPurify.sanitize(this.activeProperty.long_description ?? '')
    }
  }
}
</script>
